import type {SavedViewsResponse} from '../types'

export function canShowCreateAction({
  savedViews,
  teamPersonalEnabled,
}: {
  savedViews: SavedViewsResponse | undefined
  teamPersonalEnabled: boolean
}): boolean {
  if (!savedViews?.viewerCanManageViews) return false

  const legacyBlankslateOwnsCreateAction = !teamPersonalEnabled && savedViews.savedViews.length === 0
  return !legacyBlankslateOwnsCreateAction
}
